import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as IconFeedback } from '../../assets/svg/icon-feedback.svg';
import { ReactComponent as IconClose } from '../../assets/svg/icon-close-custom.svg';
import { IS_IE } from '../../services/PlatformCheckerService';


export default class SurveyButton extends PureComponent {
  static propTypes = {
    display: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    href: PropTypes.string.isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    onClose: null,
    className: '',
  };

  _renderCloseButton = () => {
    const { onClose } = this.props;
    return (
      <div className="survey-button-close-button" role="button" onClick={onClose} onKeyPress={onClose} tabIndex={0} aria-label="click to close give us feed back link">
        <IconClose className="survey-button-close-icon" role="img" />
      </div>
    );
  };

  _renderIcon = () => <IconFeedback className="survey-button-icon" role="img" aria-hidden="true" focusable="false" />;

  _renderText = () => (
    <p className="survey-button-text">
      Give us feedback
    </p>
  );

  _renderMobile = () => {
    const { onClose, href } = this.props;
    return (
      <div className="row survey-button-content survey-button-content--mobile col-xs-10 col-sm-6 col-xs-offset-1 col-sm-offset-3">
        <div className="survey-button-content__separator" />
        <a id="survey-link" className="survey-link survey-link-mobile at-btn" onClick={onClose} href={href} rel="noopener noreferrer" target="_blank">
          {this._renderIcon()}
          {this._renderText()}
        </a>
        {this._renderCloseButton()}
      </div>
    );
  };

  _renderDesktop = () => {
    const { onClose, href } = this.props;

    const linkClassNames = IS_IE ? 'survey-link-desktop-ie' : '';
    return (
      <div className="survey-button-content survey-button-content--desktop">
        <a id="survey-link" className={`survey-link survey-link-desktop ${linkClassNames}`} onClick={onClose} href={href} target="_blank" rel="noopener noreferrer">
          {this._renderIcon()}
          {this._renderText()}
        </a>
        {this._renderCloseButton()}
        <div className="survey-button-container__tick" />
      </div>
    );
  };

  render() {
    const { display, className } = this.props;
    if (!display) {
      return null;
    }

    return (
      <div className={`survey-button-container ${className}`}>
        {this._renderMobile()}
        {this._renderDesktop()}
      </div>
    );
  }
}